/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  PaginatedSaasInvoiceList,
  PaginatedSaasPaymentList,
  PaginatedSaasReminderList,
  SaasInvoice,
  SaasInvoiceDocument,
  SaasInvoicesListParams,
  SaasPayStart,
  SaasPayStartRequest,
  SaasPayment,
  SaasPaymentsListParams,
  SaasPlan,
  SaasReminder,
  SaasRemindersListParams,
  SaasSimulateRequest,
  SaasStatus,
  SaasUsage
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type saasInvoicesListResponse200 = {
  data: PaginatedSaasInvoiceList
  status: 200
}
    
export type saasInvoicesListResponseSuccess = (saasInvoicesListResponse200) & {
  headers: Headers;
};
;

export type saasInvoicesListResponse = (saasInvoicesListResponseSuccess)

export const getSaasInvoicesListUrl = (params?: SaasInvoicesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/saas/invoices/?${stringifiedParams}` : `/api/v1/saas/invoices/`
}

export const saasInvoicesList = async (params?: SaasInvoicesListParams, options?: RequestInit): Promise<saasInvoicesListResponse> => {
  
  return apiFetch<saasInvoicesListResponse>(getSaasInvoicesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasInvoicesListQueryKey = (params?: SaasInvoicesListParams,) => {
    return [
    `/api/v1/saas/invoices/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSaasInvoicesListQueryOptions = <TData = Awaited<ReturnType<typeof saasInvoicesList>>, TError = unknown>(params?: SaasInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasInvoicesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasInvoicesList>>> = ({ signal }) => saasInvoicesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasInvoicesListQueryResult = NonNullable<Awaited<ReturnType<typeof saasInvoicesList>>>
export type SaasInvoicesListQueryError = unknown


export function useSaasInvoicesList<TData = Awaited<ReturnType<typeof saasInvoicesList>>, TError = unknown>(
 params: undefined |  SaasInvoicesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof saasInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasInvoicesList<TData = Awaited<ReturnType<typeof saasInvoicesList>>, TError = unknown>(
 params?: SaasInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasInvoicesList>>,
          TError,
          Awaited<ReturnType<typeof saasInvoicesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasInvoicesList<TData = Awaited<ReturnType<typeof saasInvoicesList>>, TError = unknown>(
 params?: SaasInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasInvoicesList<TData = Awaited<ReturnType<typeof saasInvoicesList>>, TError = unknown>(
 params?: SaasInvoicesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasInvoicesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type saasInvoicesRetrieveResponse200 = {
  data: SaasInvoice
  status: 200
}
    
export type saasInvoicesRetrieveResponseSuccess = (saasInvoicesRetrieveResponse200) & {
  headers: Headers;
};
;

export type saasInvoicesRetrieveResponse = (saasInvoicesRetrieveResponseSuccess)

export const getSaasInvoicesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/saas/invoices/${id}/`
}

export const saasInvoicesRetrieve = async (id: string, options?: RequestInit): Promise<saasInvoicesRetrieveResponse> => {
  
  return apiFetch<saasInvoicesRetrieveResponse>(getSaasInvoicesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasInvoicesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/saas/invoices/${id}/`
    ] as const;
    }

    
export const getSaasInvoicesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasInvoicesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasInvoicesRetrieve>>> = ({ signal }) => saasInvoicesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasInvoicesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof saasInvoicesRetrieve>>>
export type SaasInvoicesRetrieveQueryError = unknown


export function useSaasInvoicesRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasInvoicesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasInvoicesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasInvoicesRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasInvoicesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasInvoicesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasInvoicesRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasInvoicesRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasInvoicesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The invoice with the operator's header and legal mentions (printable HTML).
 */
export type saasInvoicesDocumentRetrieveResponse200 = {
  data: SaasInvoiceDocument
  status: 200
}
    
export type saasInvoicesDocumentRetrieveResponseSuccess = (saasInvoicesDocumentRetrieveResponse200) & {
  headers: Headers;
};
;

export type saasInvoicesDocumentRetrieveResponse = (saasInvoicesDocumentRetrieveResponseSuccess)

export const getSaasInvoicesDocumentRetrieveUrl = (id: string,) => {


  

  return `/api/v1/saas/invoices/${id}/document/`
}

export const saasInvoicesDocumentRetrieve = async (id: string, options?: RequestInit): Promise<saasInvoicesDocumentRetrieveResponse> => {
  
  return apiFetch<saasInvoicesDocumentRetrieveResponse>(getSaasInvoicesDocumentRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasInvoicesDocumentRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/saas/invoices/${id}/document/`
    ] as const;
    }

    
export const getSaasInvoicesDocumentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasInvoicesDocumentRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>> = ({ signal }) => saasInvoicesDocumentRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasInvoicesDocumentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>>
export type SaasInvoicesDocumentRetrieveQueryError = unknown


export function useSaasInvoicesDocumentRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasInvoicesDocumentRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasInvoicesDocumentRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasInvoicesDocumentRetrieve<TData = Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasInvoicesDocumentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasInvoicesDocumentRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type saasInvoicesPayCreateResponse201 = {
  data: SaasPayStart
  status: 201
}
    
export type saasInvoicesPayCreateResponseSuccess = (saasInvoicesPayCreateResponse201) & {
  headers: Headers;
};
;

export type saasInvoicesPayCreateResponse = (saasInvoicesPayCreateResponseSuccess)

export const getSaasInvoicesPayCreateUrl = (id: string,) => {


  

  return `/api/v1/saas/invoices/${id}/pay/`
}

export const saasInvoicesPayCreate = async (id: string,
    saasPayStartRequest: SaasPayStartRequest, options?: RequestInit): Promise<saasInvoicesPayCreateResponse> => {
  
  return apiFetch<saasInvoicesPayCreateResponse>(getSaasInvoicesPayCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saasPayStartRequest,)
  }
);}




export const getSaasInvoicesPayCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saasInvoicesPayCreate>>, TError,{id: string;data: SaasPayStartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saasInvoicesPayCreate>>, TError,{id: string;data: SaasPayStartRequest}, TContext> => {

const mutationKey = ['saasInvoicesPayCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saasInvoicesPayCreate>>, {id: string;data: SaasPayStartRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  saasInvoicesPayCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaasInvoicesPayCreateMutationResult = NonNullable<Awaited<ReturnType<typeof saasInvoicesPayCreate>>>
    export type SaasInvoicesPayCreateMutationBody = SaasPayStartRequest
    export type SaasInvoicesPayCreateMutationError = unknown

    export const useSaasInvoicesPayCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saasInvoicesPayCreate>>, TError,{id: string;data: SaasPayStartRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saasInvoicesPayCreate>>,
        TError,
        {id: string;data: SaasPayStartRequest},
        TContext
      > => {

      const mutationOptions = getSaasInvoicesPayCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type saasPaymentsListResponse200 = {
  data: PaginatedSaasPaymentList
  status: 200
}
    
export type saasPaymentsListResponseSuccess = (saasPaymentsListResponse200) & {
  headers: Headers;
};
;

export type saasPaymentsListResponse = (saasPaymentsListResponseSuccess)

export const getSaasPaymentsListUrl = (params?: SaasPaymentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/saas/payments/?${stringifiedParams}` : `/api/v1/saas/payments/`
}

export const saasPaymentsList = async (params?: SaasPaymentsListParams, options?: RequestInit): Promise<saasPaymentsListResponse> => {
  
  return apiFetch<saasPaymentsListResponse>(getSaasPaymentsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasPaymentsListQueryKey = (params?: SaasPaymentsListParams,) => {
    return [
    `/api/v1/saas/payments/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSaasPaymentsListQueryOptions = <TData = Awaited<ReturnType<typeof saasPaymentsList>>, TError = unknown>(params?: SaasPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasPaymentsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasPaymentsList>>> = ({ signal }) => saasPaymentsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasPaymentsListQueryResult = NonNullable<Awaited<ReturnType<typeof saasPaymentsList>>>
export type SaasPaymentsListQueryError = unknown


export function useSaasPaymentsList<TData = Awaited<ReturnType<typeof saasPaymentsList>>, TError = unknown>(
 params: undefined |  SaasPaymentsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasPaymentsList>>,
          TError,
          Awaited<ReturnType<typeof saasPaymentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasPaymentsList<TData = Awaited<ReturnType<typeof saasPaymentsList>>, TError = unknown>(
 params?: SaasPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasPaymentsList>>,
          TError,
          Awaited<ReturnType<typeof saasPaymentsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasPaymentsList<TData = Awaited<ReturnType<typeof saasPaymentsList>>, TError = unknown>(
 params?: SaasPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasPaymentsList<TData = Awaited<ReturnType<typeof saasPaymentsList>>, TError = unknown>(
 params?: SaasPaymentsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasPaymentsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type saasPaymentsRetrieveResponse200 = {
  data: SaasPayment
  status: 200
}
    
export type saasPaymentsRetrieveResponseSuccess = (saasPaymentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type saasPaymentsRetrieveResponse = (saasPaymentsRetrieveResponseSuccess)

export const getSaasPaymentsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/saas/payments/${id}/`
}

export const saasPaymentsRetrieve = async (id: string, options?: RequestInit): Promise<saasPaymentsRetrieveResponse> => {
  
  return apiFetch<saasPaymentsRetrieveResponse>(getSaasPaymentsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasPaymentsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/saas/payments/${id}/`
    ] as const;
    }

    
export const getSaasPaymentsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasPaymentsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasPaymentsRetrieve>>> = ({ signal }) => saasPaymentsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasPaymentsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof saasPaymentsRetrieve>>>
export type SaasPaymentsRetrieveQueryError = unknown


export function useSaasPaymentsRetrieve<TData = Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasPaymentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasPaymentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasPaymentsRetrieve<TData = Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasPaymentsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasPaymentsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasPaymentsRetrieve<TData = Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasPaymentsRetrieve<TData = Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPaymentsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasPaymentsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Local simulator only (sandbox without a key): no money.
 */
export type saasPaymentsSimulateCreateResponse202 = {
  data: SaasPayment
  status: 202
}
    
export type saasPaymentsSimulateCreateResponseSuccess = (saasPaymentsSimulateCreateResponse202) & {
  headers: Headers;
};
;

export type saasPaymentsSimulateCreateResponse = (saasPaymentsSimulateCreateResponseSuccess)

export const getSaasPaymentsSimulateCreateUrl = (id: string,) => {


  

  return `/api/v1/saas/payments/${id}/simulate/`
}

export const saasPaymentsSimulateCreate = async (id: string,
    saasSimulateRequest: SaasSimulateRequest, options?: RequestInit): Promise<saasPaymentsSimulateCreateResponse> => {
  
  return apiFetch<saasPaymentsSimulateCreateResponse>(getSaasPaymentsSimulateCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saasSimulateRequest,)
  }
);}




export const getSaasPaymentsSimulateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saasPaymentsSimulateCreate>>, TError,{id: string;data: SaasSimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saasPaymentsSimulateCreate>>, TError,{id: string;data: SaasSimulateRequest}, TContext> => {

const mutationKey = ['saasPaymentsSimulateCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saasPaymentsSimulateCreate>>, {id: string;data: SaasSimulateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  saasPaymentsSimulateCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaasPaymentsSimulateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof saasPaymentsSimulateCreate>>>
    export type SaasPaymentsSimulateCreateMutationBody = SaasSimulateRequest
    export type SaasPaymentsSimulateCreateMutationError = unknown

    export const useSaasPaymentsSimulateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saasPaymentsSimulateCreate>>, TError,{id: string;data: SaasSimulateRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saasPaymentsSimulateCreate>>,
        TError,
        {id: string;data: SaasSimulateRequest},
        TContext
      > => {

      const mutationOptions = getSaasPaymentsSimulateCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The published plans (and the agency's own plan, even unpublished).
 */
export type saasPlansListResponse200 = {
  data: SaasPlan[]
  status: 200
}
    
export type saasPlansListResponseSuccess = (saasPlansListResponse200) & {
  headers: Headers;
};
;

export type saasPlansListResponse = (saasPlansListResponseSuccess)

export const getSaasPlansListUrl = () => {


  

  return `/api/v1/saas/plans/`
}

export const saasPlansList = async ( options?: RequestInit): Promise<saasPlansListResponse> => {
  
  return apiFetch<saasPlansListResponse>(getSaasPlansListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasPlansListQueryKey = () => {
    return [
    `/api/v1/saas/plans/`
    ] as const;
    }

    
export const getSaasPlansListQueryOptions = <TData = Awaited<ReturnType<typeof saasPlansList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPlansList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasPlansListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasPlansList>>> = ({ signal }) => saasPlansList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasPlansList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasPlansListQueryResult = NonNullable<Awaited<ReturnType<typeof saasPlansList>>>
export type SaasPlansListQueryError = unknown


export function useSaasPlansList<TData = Awaited<ReturnType<typeof saasPlansList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPlansList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasPlansList>>,
          TError,
          Awaited<ReturnType<typeof saasPlansList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasPlansList<TData = Awaited<ReturnType<typeof saasPlansList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPlansList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasPlansList>>,
          TError,
          Awaited<ReturnType<typeof saasPlansList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasPlansList<TData = Awaited<ReturnType<typeof saasPlansList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPlansList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasPlansList<TData = Awaited<ReturnType<typeof saasPlansList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasPlansList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasPlansListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The in-app reminders (history of the e-mails).
 */
export type saasRemindersListResponse200 = {
  data: PaginatedSaasReminderList
  status: 200
}
    
export type saasRemindersListResponseSuccess = (saasRemindersListResponse200) & {
  headers: Headers;
};
;

export type saasRemindersListResponse = (saasRemindersListResponseSuccess)

export const getSaasRemindersListUrl = (params?: SaasRemindersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/saas/reminders/?${stringifiedParams}` : `/api/v1/saas/reminders/`
}

export const saasRemindersList = async (params?: SaasRemindersListParams, options?: RequestInit): Promise<saasRemindersListResponse> => {
  
  return apiFetch<saasRemindersListResponse>(getSaasRemindersListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasRemindersListQueryKey = (params?: SaasRemindersListParams,) => {
    return [
    `/api/v1/saas/reminders/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSaasRemindersListQueryOptions = <TData = Awaited<ReturnType<typeof saasRemindersList>>, TError = unknown>(params?: SaasRemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasRemindersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasRemindersList>>> = ({ signal }) => saasRemindersList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasRemindersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasRemindersListQueryResult = NonNullable<Awaited<ReturnType<typeof saasRemindersList>>>
export type SaasRemindersListQueryError = unknown


export function useSaasRemindersList<TData = Awaited<ReturnType<typeof saasRemindersList>>, TError = unknown>(
 params: undefined |  SaasRemindersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasRemindersList>>,
          TError,
          Awaited<ReturnType<typeof saasRemindersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasRemindersList<TData = Awaited<ReturnType<typeof saasRemindersList>>, TError = unknown>(
 params?: SaasRemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasRemindersList>>,
          TError,
          Awaited<ReturnType<typeof saasRemindersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasRemindersList<TData = Awaited<ReturnType<typeof saasRemindersList>>, TError = unknown>(
 params?: SaasRemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasRemindersList<TData = Awaited<ReturnType<typeof saasRemindersList>>, TError = unknown>(
 params?: SaasRemindersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasRemindersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The in-app reminders (history of the e-mails).
 */
export type saasRemindersRetrieveResponse200 = {
  data: SaasReminder
  status: 200
}
    
export type saasRemindersRetrieveResponseSuccess = (saasRemindersRetrieveResponse200) & {
  headers: Headers;
};
;

export type saasRemindersRetrieveResponse = (saasRemindersRetrieveResponseSuccess)

export const getSaasRemindersRetrieveUrl = (id: string,) => {


  

  return `/api/v1/saas/reminders/${id}/`
}

export const saasRemindersRetrieve = async (id: string, options?: RequestInit): Promise<saasRemindersRetrieveResponse> => {
  
  return apiFetch<saasRemindersRetrieveResponse>(getSaasRemindersRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasRemindersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/saas/reminders/${id}/`
    ] as const;
    }

    
export const getSaasRemindersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasRemindersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasRemindersRetrieve>>> = ({ signal }) => saasRemindersRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasRemindersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof saasRemindersRetrieve>>>
export type SaasRemindersRetrieveQueryError = unknown


export function useSaasRemindersRetrieve<TData = Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasRemindersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasRemindersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasRemindersRetrieve<TData = Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasRemindersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasRemindersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasRemindersRetrieve<TData = Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasRemindersRetrieve<TData = Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasRemindersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasRemindersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The agency's subscription as every member sees it (banner, menu).
 */
export type saasStatusRetrieveResponse200 = {
  data: SaasStatus
  status: 200
}
    
export type saasStatusRetrieveResponseSuccess = (saasStatusRetrieveResponse200) & {
  headers: Headers;
};
;

export type saasStatusRetrieveResponse = (saasStatusRetrieveResponseSuccess)

export const getSaasStatusRetrieveUrl = () => {


  

  return `/api/v1/saas/status/`
}

export const saasStatusRetrieve = async ( options?: RequestInit): Promise<saasStatusRetrieveResponse> => {
  
  return apiFetch<saasStatusRetrieveResponse>(getSaasStatusRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasStatusRetrieveQueryKey = () => {
    return [
    `/api/v1/saas/status/`
    ] as const;
    }

    
export const getSaasStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof saasStatusRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasStatusRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasStatusRetrieve>>> = ({ signal }) => saasStatusRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasStatusRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof saasStatusRetrieve>>>
export type SaasStatusRetrieveQueryError = unknown


export function useSaasStatusRetrieve<TData = Awaited<ReturnType<typeof saasStatusRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasStatusRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasStatusRetrieve<TData = Awaited<ReturnType<typeof saasStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasStatusRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasStatusRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasStatusRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasStatusRetrieve<TData = Awaited<ReturnType<typeof saasStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasStatusRetrieve<TData = Awaited<ReturnType<typeof saasStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasStatusRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasStatusRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The agency's consumption against the quotas of its plan.
 */
export type saasUsageRetrieveResponse200 = {
  data: SaasUsage
  status: 200
}
    
export type saasUsageRetrieveResponseSuccess = (saasUsageRetrieveResponse200) & {
  headers: Headers;
};
;

export type saasUsageRetrieveResponse = (saasUsageRetrieveResponseSuccess)

export const getSaasUsageRetrieveUrl = () => {


  

  return `/api/v1/saas/usage/`
}

export const saasUsageRetrieve = async ( options?: RequestInit): Promise<saasUsageRetrieveResponse> => {
  
  return apiFetch<saasUsageRetrieveResponse>(getSaasUsageRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getSaasUsageRetrieveQueryKey = () => {
    return [
    `/api/v1/saas/usage/`
    ] as const;
    }

    
export const getSaasUsageRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof saasUsageRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasUsageRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSaasUsageRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof saasUsageRetrieve>>> = ({ signal }) => saasUsageRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof saasUsageRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SaasUsageRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof saasUsageRetrieve>>>
export type SaasUsageRetrieveQueryError = unknown


export function useSaasUsageRetrieve<TData = Awaited<ReturnType<typeof saasUsageRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasUsageRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasUsageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasUsageRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasUsageRetrieve<TData = Awaited<ReturnType<typeof saasUsageRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasUsageRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof saasUsageRetrieve>>,
          TError,
          Awaited<ReturnType<typeof saasUsageRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSaasUsageRetrieve<TData = Awaited<ReturnType<typeof saasUsageRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasUsageRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSaasUsageRetrieve<TData = Awaited<ReturnType<typeof saasUsageRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof saasUsageRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSaasUsageRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




